// Mock data for Magic Deumidificazioni clone

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Azienda', href: '#azienda' },
  { label: 'Servizi', href: '#servizi' },
  { label: 'Contatti', href: '#footer-contatti' },
];

export const features = [
  { title: 'Intervento Rapido', subtitle: 'Arriviamo entro 3 ore', icon: 'Timer' },
  { title: 'Esperti Certificati', subtitle: 'Tecnici qualificati', icon: 'ShieldCheck' },
  { title: '26 Anni di Esperienza', subtitle: 'Dal 2000 al vostro servizio', icon: 'Award' },
  { title: 'Partner di Assicurazioni', subtitle: 'Gestione pratiche inclusa', icon: 'FileCheck' },
  { title: 'Tecniche Non Invasive', subtitle: 'Soluzioni senza demolizioni', icon: 'Wrench' },
];

export const services = [
  {
    id: 'ricerca-perdite',
    title: 'Ricerca Perdite',
    description: 'Localizzazione non distruttiva di perdite occulte con termografia.',
    image: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/nc5wmag7_Ricerca%20perdite.jpg',
    icon: 'Search',
    longDescription: 'Utilizziamo le più avanzate tecnologie di termografia ad infrarossi, gas tracciante e ispezioni videoendoscopiche per localizzare perdite occulte negli impianti idrici, di riscaldamento e di scarico senza demolizioni invasive.'
  },
  {
    id: 'deumidificazione',
    title: 'Deumidificazione Stabili',
    description: 'Asciugatura professionale di ambienti, pareti e pavimenti.',
    image: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/54nng67p_Deumidificazione%20case.jpeg',
    icon: 'Wind',
    longDescription: 'Asciugatura tecnica controllata di ambienti, intercapedini, pareti, pavimenti e isolamenti dopo allagamenti, infiltrazioni o danni d\'acqua, utilizzando deumidificatori a condensazione e adsorbimento.'
  },
  {
    id: 'noleggio',
    title: 'Noleggio e Vendita Macchinari',
    description: 'Deumidificatori e ventilatori professionali a noleggio e in vendita.',
    image: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/sctfb7pc_noleggio%20e%20macchinari.JPG',
    icon: 'Wrench',
    longDescription: 'Ampio parco macchine professionali: deumidificatori a condensazione, ad adsorbimento, ventilatori assiali, riscaldatori, generatori di ozono. Disponibili a noleggio giornaliero, settimanale, mensile e in vendita.'
  },
  {
    id: 'risanamento',
    title: "Risanamento Edile Post-Danni",
    description: 'Ripristino completo di strutture danneggiate da acqua e umidità.',
    image: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/rys6tafg_allagamenti%20e%20infiltrazioni.jpg',
    icon: 'HardHat',
    longDescription: 'Interventi completi di ripristino edile dopo danni d\'acqua: demolizioni mirate, ricostruzioni, opere di muratura, intonacatura, tinteggiature, posa pavimentazioni e rifiniture.'
  },
];

export const testimonials = [
  {
    text: "Intervento rapido ed efficace! Hanno salvato la mia casa dall'allagamento. Sono arrivati in meno di un'ora e hanno gestito tutto in modo professionale. Consiglio vivamente!",
    name: 'Luca R.',
    location: 'Lugano, Ticino',
    rating: 5,
  },
  {
    text: "Professionisti seri e competenti. Hanno risolto un problema di umidità che avevamo da anni. Il team è stato puntuale e ha lasciato tutto pulito. Ottimo servizio!",
    name: 'Maria G.',
    location: 'Bellinzona, Ticino',
    rating: 5,
  },
  {
    text: "Servizio impeccabile dalla prima chiamata fino al completamento dei lavori. Hanno individuato la perdita senza rompere nulla. Lavoro di alto livello tecnico.",
    name: 'Giorgio M.',
    location: 'Mendrisio, Ticino',
    rating: 5,
  },
  {
    text: "Ho avuto un allagamento di notte e in poco tempo erano sul posto. Hanno gestito anche tutta la pratica con l'assicurazione. Davvero un servizio completo.",
    name: 'Anna T.',
    location: 'Locarno, Ticino',
    rating: 5,
  },
];

export const partners = [
  { name: 'Allianz', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Allianz_logo.svg/200px-Allianz_logo.svg.png' },
  { name: 'AXA', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/AXA_Logo.svg/200px-AXA_Logo.svg.png' },
  { name: 'Baloise', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Baloise_201x_logo.svg/200px-Baloise_201x_logo.svg.png' },
  { name: 'CSS', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/CSS_Versicherung_logo.svg/200px-CSS_Versicherung_logo.svg.png' },
  { name: 'Generali', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Generali_logo.svg/200px-Generali_logo.svg.png' },
  { name: 'Helvetia', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Helvetia_Versicherungen_logo.svg/200px-Helvetia_Versicherungen_logo.svg.png' },
  { name: 'La Mobiliare', logo: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/nhsl1vgc_Schermata%202026-03-15%20alle%2023.26.06.png' },
  { name: 'Zurich', logo: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/4fqwfntc_Schermata%202026-03-15%20alle%2023.25.26.png' },
];

export const timelineMagic = [
  { year: '2000', text: 'Inizio delle attività inerenti i servizi di deumidificazione' },
  { year: '2021', text: 'Acquisizione e ingresso in società della nuova gestione' },
  { year: '2021', text: 'Nuova sede (amministrativa e magazzino) a Mezzovico' },
  { year: '2021', text: 'Acquisizione del know-how del brand di Acqua Project' },
];

export const timelineAcqua = [
  { year: '1996', text: 'Costituzione della Wagamet in Ticino, attiva per le ricerche sugli acquedotti e per la ricerca di perdite negli stabili' },
  { year: '2004', text: "Costituzione dell'Acqua Project, attiva per la ricerca di perdite/infiltrazioni negli stabili e sui sedimi esterni, termografie per le analisi energetiche" },
  { year: '2021', text: 'Cessione delle attività, brand, know-how e portfolio clienti alla Magic Deumidificazioni Sagl' },
];

export const team = [
  { name: 'Xavier', role: 'Gerente', image: 'https://customer-assets.emergentagent.com/job_deumidificazioni-pro/artifacts/8h0266xm_f3f3c06c-3cea-42a9-959f-6eebb4d46d0d.jpg', objectPosition: '58% 30%', bgZoom: '180%' },
  { name: 'Yvana', role: 'Responsabile Vendite e Marketing', image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_deumidificazioni-pro/artifacts/t04xey3t_e2531f42-d0d5-4622-8a2d-662ba07bf5d9.png', objectPosition: '46% 38%', bgZoom: '160%' },
  { name: 'Paula', role: 'Segretaria', image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_deumidificazioni-pro/artifacts/347exg45_WhatsApp%20Image%202026-07-15%20at%2023.13.01.jpeg', objectPosition: '50% 30%', bgZoom: '130%' },
  { name: 'Jean', role: 'Tecnico Deumidificazioni', image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_deumidificazioni-pro/artifacts/rvb66ayd_WhatsApp%20Image%202026-07-27%20at%2007.58.42.jpeg', objectPosition: '50% 45%', bgZoom: '130%' },
  { name: 'Loris', role: 'Tecnico Ricerca Perdite', image: 'https://customer-assets.emergentagent.com/job_deumidificazioni-pro/artifacts/qis9cyza_f85cb30d-8576-4b05-b2e8-169ccb803f00.jpg', objectPosition: '48% 50%', bgZoom: '100%' },
  { name: 'Salvatore', role: 'Tecnico Commerciale Deumidificazione', image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_deumidificazioni-pro/artifacts/dtbsfxwm_salvatore.jpeg', objectPosition: '30% 30%', bgZoom: '200%' },
];

export const beforeAfter = {
  before: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/x18krogr_Prima%20.png',
  after: 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/xfbiyn8a_dopo.png',
};

export const sedeImage = 'https://customer-assets.emergentagent.com/job_flood-response-swiss/artifacts/ah536axc_Schermata%202026-03-15%20alle%2023.46.48.png';

export const company = {
  name: 'Magic Deumidificazioni Sagl',
  vat: 'CHE 107.673.778 IVA',
  phone: '091 647 04 59',
  phoneRaw: '0916470459',
  email: 'info@magicdeumidificazioni.ch',
  address: 'Via San Mamete 78',
  city: '6805 Mezzovico, Ticino',
  whatsapp: '41916470459',
  whatsappLink: "https://wa.me/41916470459?text=Buongiorno,%20ho%20bisogno%20di%20assistenza%20urgente%20per%20un%20problema%20di%20danni%20d'acqua.",
  facebookLink: 'https://facebook.com/61591120547390',
  instagramLink: 'https://www.instagram.com/magicdeumificazioni/',
  mapsLink: 'https://maps.google.com/?q=Via+San+Mamete+78,+6805+Mezzovico,+Ticino',
  logoUrl: 'https://customer-assets.emergentagent.com/job_deumidificazioni-pro/artifacts/291mut0l_Screenshot%202026-06-22%20alle%2022.13.26.png',
  heroBgUrl: 'https://customer-assets.emergentagent.com/job_deumidificazioni-pro/artifacts/a8krupgs_ChatGPT%20Image%2022%20giu%202026%2C%2022_13_46.png',
};
